import React from 'react';
import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';
import { BASE_URL, HELP_BASE_URL } from '../../../../config';
import {
  ABOUT_US_PATH,
  ACCREDITED_URGENT_CARE_PATH,
  BLOG_PATH,
  CAREERS_PATH,
  CASE_STUDIES_PATH,
  CONTACTLESS_DEMO_PATH,
  COVID_PATH,
  COVID_TESTING_PATH,
  COVID_VACCINE_PATH,
  EBOOKS_PATH,
  FAQ_PATH,
  FIND_CARE_PATH,
  FIND_PATH,
  FOR_PROVIDERS_BLOG_PATH,
  FOR_PROVIDERS_COVID_TESTING_VACCINE_PATH,
  FOR_PROVIDERS_PATH,
  FOR_PROVIDERS_PRICING_PATH,
  HEALTH_AZ_PATH,
  INTEGRATIONS_PATH,
  LAB_TESTS_PATH,
  PATIENT_BOOST_PATH,
  PEDIATRIC_NEAR_ME_PATH,
  PRESS_PATH,
  REQUEST_DEMO_PATH,
  URGENT_CARE_MARKETING_PATH,
  URGENT_CARE_PATH,
  VA_URGENT_CARE_NEAR_ME_PATH,
  VIDEO_TELEMEDICINE_PATH,
  WALK_IN_CLINIC_NEAR_ME_PATH,
  WEBINARS_PATH,
} from '../../../../constants';
import AppStoreBadge from '../../../DownloadDriver/AppStoreBadge';
import { campaignNames } from '~/core/analytics/events';
import { colors } from '~/constants/colors';
import { fontFamily, fontSize } from '~/constants/text';
import { biggerThan, breakpoints } from '~/core/util/styledComponents';
import { DESKTOP_FAT_GUTTER, DESKTOP_THIN_GUTTER } from '~/constants/layout';
import { remixUrl } from '~/core/remix';

const SectionTitle = styled.h5.withConfig({ componentId: 'sc-9561hk-0' })`
  color: ${colors.white}!important;
  font-family: ${fontFamily.bold}!important;
  -webkit-font-smoothing: antialiased;
  font-size: ${fontSize.default};
  font-family: ${fontFamily.bold};
  line-height: 20px;
  margin-bottom: 10px;
  a {
    cursor: pointer;
    color: ${colors.white}!important;
    text-decoration: none;
  }
  a:visited {
    color: ${colors.borderLine}!important;
  }
`;

const Link = styled.div.withConfig({ componentId: 'sc-9561hk-1' })`
  color: ${colors.borderLine}!important;
  font-family: ${fontFamily.bold};
  -webkit-font-smoothing: antialiased;
  line-height: 24px;
  font-size: 12px;
  a {
    cursor: pointer;
    color: ${colors.borderLine};
    text-decoration: none;
  }
  a:visited {
    color: ${colors.borderLine}!important;
  }
`;

const ContentContainer = styled(Grid).withConfig({ componentId: 'sc-9561hk-2' })`
  max-width: ${breakpoints.lg};
  margin: 0 auto;
`;

const Sections = styled(Grid).withConfig({ componentId: 'sc-9561hk-3' })`
  padding-bottom: 24px;
  padding-right: ${DESKTOP_FAT_GUTTER}px;
  padding-left: ${DESKTOP_FAT_GUTTER}px;
  ${biggerThan.lg`
    padding-right: ${DESKTOP_THIN_GUTTER}px;
    padding-left: ${DESKTOP_THIN_GUTTER}px;
  `};
  background-color: ${colors.squid};
  color: ${colors.white};
`;

const ForProvidersSection = styled.div.withConfig({ componentId: 'sc-9561hk-4' })`
  max-width: 300px;
  a {
    cursor: pointer;
    color: ${colors.borderLine}!important;
    -webkit-font-smoothing: antialiased;
    font-weight: bold;
    font-family: ${fontFamily.book};
    font-size: 12px;
    line-height: 24px;
  }
`;

const Section = styled(Grid).withConfig({ componentId: 'sc-9561hk-5' })`
  margin-top: 33px;
`;

const SectionMenu = styled.div.withConfig({ componentId: 'sc-9561hk-6' })`
  margin-top: 5px;
`;

const Desktop = () => {
  return (
    <Sections>
      <ContentContainer container>
        <Section item md={3}>
          <SectionTitle>
            <a href={`${remixUrl(FIND_PATH)}`}>Find Care</a>
          </SectionTitle>

          <SectionMenu>
            <Link>
              <a href={`${BASE_URL}${COVID_TESTING_PATH}`}>COVID Testing Near Me</a>
            </Link>

            <Link>
              <a href={`${BASE_URL}${COVID_VACCINE_PATH}`}>COVID Vaccine Near Me</a>
            </Link>
            <Link>
              <a href={`${BASE_URL}${URGENT_CARE_PATH}`}>Urgent Care Near Me</a>
            </Link>

            <Link>
              <a href={`${BASE_URL}${PEDIATRIC_NEAR_ME_PATH}`}>Pediatric Urgent Care Near Me</a>
            </Link>

            <Link>
              <a href={`${BASE_URL}${WALK_IN_CLINIC_NEAR_ME_PATH}`}>Walk-in Clinic Near Me</a>
            </Link>

            <Link>
              <a href={`${BASE_URL}${VA_URGENT_CARE_NEAR_ME_PATH}`}>VA Urgent Care Near Me</a>
            </Link>

            <Link>
              <a href={`${BASE_URL}${ACCREDITED_URGENT_CARE_PATH}`}>
                Certified & Accredited Urgent Care
              </a>
            </Link>

            <Link>
              <a href={`${BASE_URL}${LAB_TESTS_PATH}`}>Lab Tests Near Me</a>
            </Link>
            <Link>
              <a href={`${BASE_URL}${FIND_CARE_PATH}`}>View All Care Options</a>
            </Link>
          </SectionMenu>
        </Section>

        <Section item md={2}>
          <SectionTitle>
            <a href={`${BASE_URL}${BLOG_PATH}`}>Resources</a>
          </SectionTitle>

          <SectionMenu>
            <Link>
              <a href={`${BASE_URL}${COVID_PATH}`}>COVID Care Guide</a>
            </Link>

            <Link>
              <a href={`${BASE_URL}${BLOG_PATH}`}>In Good Health Blog</a>
            </Link>

            <Link>
              <a href={`${BASE_URL}${FAQ_PATH}`}>Health FAQs</a>
            </Link>

            <Link>
              <a href={`${BASE_URL}${HEALTH_AZ_PATH}`}>Health A-Z</a>
            </Link>

            <Link>
              <a href={HELP_BASE_URL}>Help</a>
            </Link>
          </SectionMenu>
        </Section>

        <Section item md={2}>
          <SectionTitle>
            <a href={`${BASE_URL}${ABOUT_US_PATH}`}>About Us</a>
          </SectionTitle>

          <SectionMenu>
            <Link>
              <a href={`${BASE_URL}${CAREERS_PATH}`}>Careers</a>
            </Link>

            <Link>
              <a href={`${BASE_URL}${PRESS_PATH}`}>Press</a>
            </Link>

            <Link>
              <a href="mailto:info@solvhealth.com">Contact</a>
            </Link>
          </SectionMenu>
        </Section>

        <Section item md={2}>
          <SectionTitle>Get Our App</SectionTitle>
          <SectionMenu>
            <AppStoreBadge campaignName={campaignNames.DESKTOP_FOOTER} newWindow store="ios" />
            <AppStoreBadge campaignName={campaignNames.DESKTOP_FOOTER} newWindow store="android" />
          </SectionMenu>
        </Section>

        <Section item md={3}>
          <SectionTitle>
            <a href={`${BASE_URL}${FOR_PROVIDERS_PATH}`}>For Providers</a>
          </SectionTitle>

          <ForProvidersSection>
            <Grid align-items="flex-start" container>
              <Grid item xs={6}>
                <Link>
                  <a href={`${BASE_URL}${FOR_PROVIDERS_PATH}`}>Patient Experience</a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${CONTACTLESS_DEMO_PATH}`}>Contactless Checkin</a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${PATIENT_BOOST_PATH}`}>Patient Acquisition</a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${VIDEO_TELEMEDICINE_PATH}`}>Telemedicine</a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${INTEGRATIONS_PATH}`}>EHR Integration</a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${URGENT_CARE_MARKETING_PATH}`}>Urgent Care Marketing</a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${FOR_PROVIDERS_COVID_TESTING_VACCINE_PATH}`}>
                    COVID Solutions
                  </a>
                </Link>
              </Grid>
              <Grid item xs={6}>
                <Link>
                  <a href={`${BASE_URL}${FOR_PROVIDERS_PRICING_PATH}`}>Pricing</a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${REQUEST_DEMO_PATH}`}>Request a Demo </a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${FOR_PROVIDERS_BLOG_PATH}`}>Provider Blog</a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${CASE_STUDIES_PATH}`}>Case Studies</a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${WEBINARS_PATH}`}>Webinars</a>
                </Link>

                <Link>
                  <a href={`${BASE_URL}${EBOOKS_PATH}`}>eBooks</a>
                </Link>
              </Grid>
            </Grid>
          </ForProvidersSection>
        </Section>
      </ContentContainer>
    </Sections>
  );
};

export default Desktop;
